<ion-button id="click-trigger">
  <ion-icon name="person-circle-outline" slot="start"></ion-icon>
  {{ user?.profile?.firstname || 'Usuario' }}
</ion-button>
<ion-popover trigger="click-trigger" triggerAction="click" [isOpen]="isOpen"
#popover
(didDismiss)="onPopoverDismiss()">
  <ng-template>
    <ion-content class="ion-padding">
      <b>{{user?.profile?.firstname}} {{user?.profile?.lastname}}</b><br>
      <small>{{user?.profile?.email}}</small>
      <hr style="border-bottom: 2px solid #dad9d9;">

      <ion-list lines="none" class="dropdown-list">
        @for (item of menuItems; track item.action) {
        <ion-item button detail="false" (click)="onItemClick(item); popover.dismiss()" [color]="item.color || 'light'"
          class="dropdown-item">
          <ion-icon [name]="item.icon" slot="start" class="item-icon"></ion-icon>
          <ion-label>{{ item.label }}</ion-label>
        </ion-item>
        }
      </ion-list>
    </ion-content>
  </ng-template>
</ion-popover>